import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getHub } from './get-hub';

/** `PUT /client/:cid/hubs/:hub_id/cross-clustering {enabled}`, then the hub as cb returned it. */
export const updateHubCrossClustering = async (hub_id: string, enable: boolean): Promise<any> => {
  await lpRequest('PUT', clientPath(`/hubs/${hub_id}/cross-clustering`), {
    body: { enabled: enable === true }
  });

  return getHub(hub_id);
};
